import { render } from "./StatusesTable.vue?vue&type=template&id=8b71a1de&scoped=true"
import script from "./StatusesTable.vue?vue&type=script&lang=js"
export * from "./StatusesTable.vue?vue&type=script&lang=js"

import "./StatusesTable.vue?vue&type=style&index=0&id=8b71a1de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b71a1de"]])

export default __exports__